import { createSelector } from 'reselect';

import { ChannelType } from '~/constants';

const getAgents = ({ channel_manager: { agents } }) => agents;
const getChannels = ({ channel_manager: { channels } }) => channels;
const getChannelMgr = ({ channel_manager }) => channel_manager;

const getSelectedConversation = ({ conversations: { selectedConversation } }) =>
  selectedConversation;

const getStories = ({ stories }) => stories;
const getDrafts = (formName) => (store) => store.forms[formName].drafts;
const getCurrentChannel = ({ forms: { currentChannel } }) => currentChannel;

const getAllowedChannels = createSelector(getChannelMgr, (channelMgr) =>
  channelMgr.channels
    .filter(({ type }) => type !== ChannelType.ECHO)
    .sort((a, b) => a.config.name.localeCompare(b.config.name))
);

const getAllowedAgents = createSelector(getAgents, (items) =>
  items.filter(({ channel_type }) => channel_type !== ChannelType.ECHO)
);

const getCustomerConversation = (conversationID) => (state) =>
  state[`conversation_${conversationID}`];

const getModal = (name) => (state) => state.modals[name];

const getCurrentChatAgentID = ({ global: { curChatAgentID } }) =>
  curChatAgentID;

const getCurrentChatAgent = ({
  channel_manager: { agents },
  global: { curChatAgentID },
}) => agents.find((agent) => agent.id === curChatAgentID);

const getScrollToBottom = (state) => state.conversations.scrollToBottom;

export {
  getAgents,
  getChannelMgr,
  getSelectedConversation,
  getAllowedChannels,
  getAllowedAgents,
  getStories,
  getDrafts,
  getCurrentChannel,
  getCustomerConversation,
  getModal,
  getCurrentChatAgentID,
  getCurrentChatAgent,
  getScrollToBottom,
  getChannels,
};

export * from './mw_links';
export * from './conversationsFilters';
export * from './global';
export * from './user';
